import React from "react";

import { doNothing } from "@examspark/common";
import {
  ExamBlobs,
  ExamItemResponses,
  Resource,
  SerializedHighlight,
} from "@examspark/types";

import { ItemPosition } from "../../../utils/sections";

import { ExamReducerActions } from "./reducer";

export interface Accessibility {
  fontSize?: FontSize;
}

export type FontSize = "small" | "normal" | "large" | "xlarge" | "huge";

export interface ExamState {
  count: number;
  isCompleted?: boolean;
  isPaused?: boolean;
  /** Modal to show that saves and allows user to exit. */
  isPausedWithExitPrompt?: boolean;
  flaggedItemIds: string[];
  position: ItemPosition;
  windowSize?: DOMRectReadOnly;
  accessibility?: Accessibility;
  /** Contains exam and question data used to effectively play the exam */
  exam?: Resource;
  responses?: ExamItemResponses;

  blobs?: ExamBlobs;

  highlights?: {
    [placementId: string]: SerializedHighlight[];
  };

  // if null, dont shuffle
  shuffleSeed?: string | null;
  // Controls how you can navigate the exam sections
  // Default is "non-linear" (aka, free navigation)
  itemNavigationMode: "linear" | "non-linear";
  sectionNavigationMode: "linear" | "non-linear";
}

export const defaultState: ExamState = {
  count: 1,
  isPaused: false,
  isCompleted: false,
  accessibility: {
    fontSize: "normal",
  },
  flaggedItemIds: [],
  position: {
    form: 0,
    section: 0,
    question: 0,
  },
  itemNavigationMode: "non-linear",
  sectionNavigationMode: "non-linear",
  responses: {},
  blobs: {},
};

export const ExamContext = React.createContext<
  [ExamState, React.Dispatch<ExamReducerActions>]
>([defaultState, doNothing]);
